import { ApolloCache, ApolloClient } from '@apollo/client'
import {
  removeFromPaginated,
  removeFromStorageItemsList,
} from '@sketch/modules-common'
import { ShareListItemFragment } from '@sketch/gql-types'

export interface HandleShareDeletedProps {
  cache: ApolloCache<any> | ApolloClient<any>
  identifier: string
  workspaceIdentifier: string
}

export const handleShareDeleted = (props: HandleShareDeletedProps) => {
  const { cache, identifier } = props
  const apolloCache = 'cache' in cache ? cache.cache : cache

  const targetShare = { __typename: 'Share', identifier } satisfies Pick<
    ShareListItemFragment,
    'identifier' | '__typename'
  >

  // First of all - let's remove share from all paginated queries
  removeFromPaginated(cache, targetShare, key => key.includes('.shares'))
  removeFromStorageItemsList({ cache, target: targetShare })

  // In case the share is still in our cache (in non paginated queries) let's evict it
  apolloCache.evict({ id: apolloCache.identify(targetShare) })
}
